<template>
  <b-modal
    id="offer-salary-modal"
    size="lg"
    :title-html="'<i class=\'uil-coins text-success\'></i> Offer Salary to Candidate ' + (applicant.candidate_id ? applicant.candidate_id.full_name : '')"
    title-class="font-18"
    no-close-on-esc
    no-close-on-backdrop
    centered
    body-class="bg-light"
    static
    :ok-title-html= " '<i class=\'uil-message\'></i>' + $t('job.applicant_window.action.offer_salary.ok_button')"
    ok-variant="success"
    @ok="handleOk"
    button-size= 'sm'
    :cancel-title= "$t('job.applicant_window.action.offer_salary.cancel_button')"
    footer-class= 'p-2'
    hide-header-close
    >
    
    <div class="row">
      <div class="text-center loaderko" v-if="loading">
        <div class="spinner-grow text-primary m-2 " role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="text-muted small">Loading</div>
      </div>
      <div class="form-group col-md-6">
        <label for="" class="form-label">{{$t('job.applicant_window.action.offer_salary.salary_offer.label')}}</label>
        <currency-input
          v-model="model.salary"
          class="form-control"
          placeholder="xxx,xxx"
          :precision=2
        />
      </div>
      <div class="form-group col-md-12">
        <label class="form-label">{{$t('job.applicant_window.action.offer_salary.job_offer.label')}}</label>
        <textarea 
          class="form-control"
          v-model="model.description"
          rows="10" :placeholder="$t('job.applicant_window.action.offer_salary.job_offer.placeholder') + '...'"></textarea>
        <div class="small text-danger text-right">Job offer will be included in email</div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import  FormMixin from '@mixins/form'

export default {
  mixins:[FormMixin],
  data(){
    return {
      model:{
        salary:0,
        description:''
      }
    }
  },
  props:['application'],
  computed:{
    applicant(){
      return this.$props.application || []
    }
  },
  methods:{
    ...mapActions('candidate', ['offerCandidate']),
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
     /*  let job = this.applicant.job_id */

      /* if(this.model.salary < job.min_salary.$numberDecimal || this.model.salary > job.max_salary.$numberDecimal){
        alert('Please enter your offer salary within ' + job.min_salary.$numberDecimal + ' - ' + job.max_salary.$numberDecimal)
        return
      } */

      if(!this.model.description){
        alert('Please enter Job Offer')
        return
      }
      if(!this.loading){
        this.toggleLoading()
        this.offerCandidate({
          ...this.model,
          id:this.applicant._id
        }).then(res => {
          if(res.data){
            this.$parent.$data.applicant = res.data
            /* this.$props.application = res.data */
            this.$bvModal.hide('offer-salary-modal')
            this.$bvToast.toast(`Your offer to candidate was successfully save and emailed.`, {
              title: 'Notification',
              variant:'success'
            })
            this.toggleLoading()
          }
        })
      }
      
    }
  },
  filters:{
    date:function(v){
      return moment(v).format('MMM DD, YYYY LT')
    }
  }
}
</script>




<style lang="scss">

.loaderko{
  position: absolute;
  height: 100%;
  z-index: 9;
  background: #ffffffc7;
  width: 100%;
  left: 0;
  top: 0;
}
</style>